import { Card, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import LanguageForm from "../../../components/forms/LanguageForm";
import LanguageService from "../../../services/language.service";
import UserPermissionService from "../../../services/userPermission.service";

const LanguageDetails = () => {

    const params = useParams();

    const navigate = useNavigate();

    const { t } = useTranslation();
    
    const [language, setLanguage] = useState({});

    const [title, setTitle] = useState("");

    const [success, setSuccess] = useState({
        update: false,
        email: false,
    });

    const [errors, setErrors] = useState({
        update: false,
    });

    const [permissions, setPermissions] = useState({});

    const getLanguage = useCallback(async (id) => {
        try {
            const data = await LanguageService.getById(id);
            setLanguage(data);
            setTitle(data.name);
        } catch (e) {
            navigate("/language");
        }
    }, [navigate]);

    const getPermissions = async () => {
        try {
            const data = await UserPermissionService.getPermissionsByConnected();
            setPermissions(data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        const loadData = async () => {
            await getPermissions();
        }

        loadData();
    }, []);

    useEffect(() => {
        getLanguage(params.id);
    }, [getLanguage, params.id]);

    const updateLanguage = async (data) => {
        setErrors({...errors, update: false});
        setSuccess({...success, update: false});
        try {
            await LanguageService.update(params.id, data);
            setSuccess({...success, update: true});
        } catch (e) {
            setErrors({...errors, update: true});
        }
    };

    return (
        <>
            <div className={"d-flex justify-content-between my-3"}>
                <Link to="/language" className={"previous round rounded-circle text-decoration-none"}
                    title={t('general.back')}>
                    <FontAwesomeIcon icon={"chevron-left"} className={"mt-2 me-2"} />
                    <span>{t('languages.title')}</span>
                </Link>
            </div>
            <Alert variant={"success"} show={success.update} dismissible onClose={() => setSuccess({...success, update: false})}>
                {t('languages.success.update')}
            </Alert>
            <Alert variant={"danger"} show={errors.update} dismissible onClose={() => setErrors({...errors, update: false})}>
                {t('languages.error.update')}
            </Alert>
            <Card>
                <Card.Header className={"py-3"}>
                    <h1 className={"h3 mb-0 text-gray-800 card-title"}>{title}</h1>
                </Card.Header>
                <Card.Body>
                    <LanguageForm onSubmit={updateLanguage} language={language} permissions={permissions} details />
                </Card.Body>
            </Card>
        </>
    );
}

export default LanguageDetails;
